<script setup>
const props = defineProps({
    sponsors: {
        type: Array,
        required: true,
    },
});

const firstSponsor = computed(() => {
    return props.sponsors?.find((sponsor) => sponsor?.url?.length > 0);
});
</script>

<template>
    <div v-if="firstSponsor" class="sponsored-by fs-15">
        <div class="logo">
            <MessImage :src="firstSponsor.url" :alt="firstSponsor.name + ' logo'" class="background" />
        </div>
    </div>
</template>

<style lang="scss">
.sponsored-by {

    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: 0.01875rem;

    @media(min-width: $tablet) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 2rem;
        margin-bottom: 2rem;
    }
    

    .mess-image {
        max-width: 8.8125rem;
        background: white;
        border-radius: var(--radius);
        height: auto;
        aspect-ratio: 141 / 91;

        picture {
            img {
                max-width: 8rem;
                width: 100%;
                object-fit: contain;
                object-position: center;
                aspect-ratio: 141 / 91;
            }
        }
    }
}
</style>
